import { wrapCall, callGetWithoutAccountId } from './helpers'

// Gets account list for current user
export const getAccounts = async () => {
  return await wrapCall({ method: callGetWithoutAccountId, uri: '/accounts' })
}
